export const step2EN = {
    topic:"Please pay application fee",
    step:{
        topic:'Payment process',
        step1:'Click generate QR Code',
        step2:'Open mobile banking and select "Scan QR Code"',
        step3:'Scan QR Code',
        step4:'Check amount and receiver name then click confirm',
        step5:'Achieve a payment slip',

    },
    accountName:"Account name",
    totalAmount:'Total amount',
    baht:'Baht',
    scan:'Scan QR Code',
    content:'Please scan QR code for pay application fee within',
    content2:'minutes. If QR code expired please click "Generate QR code again"',
    outOfDeadline:'Out of deadline to pay application fee',
    content_outOfDeadline:'Could not continue the process',
    pending_payment:'Pending payment'
}

export const step2TH = {
    topic:"กรุณาชำระค่าธรรมเนียมการสมัคร",
    step:{
        topic:'ขั้นตอนการชำระเงิน',
        step1:'กด “สร้าง QR Code”',
        step2:'เปิดแอป Mobile Banking เลือกเมนู “สแกน QR”',
        step3:'สแกน QR Code',
        step4:'ตรวจสอบจำนวนเงินและชื่อบัญชีโรงเรียน และกด “ชำระเงิน”',
        step5:'แนบไฟล์หลักฐานการชำระเงิน (e-Slip)',
    },
    accountName:"บัญชี",
    totalAmount:'จำนวนเงินที่ต้องชำระ',
    baht:'บาท',
    scan:'สร้าง QR Code',
    content:'โปรดสแกน QR code เพื่อชำระค่าสมัครภายใน',
    content2:'นาที หาก QR Code หมดอายุ กรุณากด “สร้าง QR Code” อีกครั้ง',
    outOfDeadline:'หมดเวลาชำระค่าธรรมเนียมการสมัคร',
    content_outOfDeadline:'ไม่สามารถดำเนินการต่อได้',
    pending_payment:'รอการชำระเงิน'
}

export const step3EN = {
    content:{
        message1:"You can check the result on this website again if qualified please print your ID card th enter the exam room",
        message2:"Please print out your identification card to enter the examination room",
        question:"If have any question please contact school's admin",
        dayExamination:"Exam Date",
        candidateInformation: 'Candidate information',
        examPeriod: "Exam period",
        firstExamPeriod: 'First exam period',
        secondExamPeriod: 'Second exam period',
        testVenue: 'Test venue',
        examDate: 'Exam date',
        announcementDate: 'Announcement date',
        applicationIDCard: 'Application ID card',
        announcementReserveResult: 'Announcement of examination result for reserve round',
        announcementFirstResult: 'Announcement of examination result for first round',
        candidateInfoDownload: 'Candidate information',
    },
    status:{
        waitAnnouncement: 'Waiting for announcement',
        noQualified: 'No qualified',
        qualified: 'Qualified',
        successfulPayment: 'Payment complete',
    }
}

export const step3TH = {
    content:{
        message1:"คุณสามารถตรวจสอบผลบนเว็บไซต์นี้อีกครั้ง หากมีสิทธิ์สอบ กรุณาพิมพ์บัตรประจำตัวเข้าห้องสอบสำหรับแสดงตนในวันสอบคัดเลือก",
        message2:"กรุณาพิมพ์บัตรประจำตัวเข้าห้องสอบสำหรับแสดงตนในวันสอบคัดเลือก",
        question:"หากมีข้อสงสัยเพิ่มเติมกรุณาติดต่อโรงเรียน",
        dayExamination:"วันสอบคัดเลือก",
        candidateInformation: 'ข้อมูลผู้สมัคร',
        examPeriod: "เวลาสอบ",
        firstExamPeriod: 'เวลาสอบช่วงที่ 1',
        secondExamPeriod: 'เวลาสอบช่วงที่ 2',
        testVenue: 'สถานที่สอบ',
        examDate: 'วันที่สอบ',
        announcementDate: 'วันที่ประกาศสิทธิ์สอบ',
        applicationIDCard: 'บัตรประจำตัวเข้าห้องสอบ',
        announcementReserveResult: 'ประกาศผลสอบคัดเลือก (รอบตัวสำรอง)',
        announcementFirstResult: 'ประกาศผลสอบคัดเลือก (รอบตัวจริง)',
        candidateInfoDownload: 'ข้อมูลผู้สมัคร',
    },
    status:{
        waitAnnouncement: 'รอประกาศสิทธิ์การเข้าสอบ',
        noQualified: 'ไม่มีสิทธิ์สอบ',
        qualified: 'มีสิทธิ์สอบ',
        successfulPayment: 'ชำระเงินสำเร็จ',
    }
}

export const step4EN = {
    topic:{
        congratulations:'Congratulations! You passed the selection',
        notPass:`Sorry, you don't pass the selection`,
        initiationDay: 'The initiation day',
    },
    content:{
        examinationResult:'Examination result',
        confirm:'Please confirm your right for initiation within the deadline. Please fill additional personal information.',
        timeout:'Out of deadline to confirm',
        name:'Firstname - Lastname',
        type:'Type',
        classroom:'Grade',
        curriculum:'Curriculum'
    },
    dialog:{
        topic:'Confirm the rights',
        content1:'After click next',
        content2:'you will not have access to edit your information',
        cancel:'Cancel',
        next:'Next'
    },
    status:{
        qualified: 'Qualified',
        noQualified: 'No qualified',
        waiver: 'Waiver',
        confirmEnrollment: 'Confirm',
        successfulWaiver: 'Successful waiver',
        confirm: 'Confirm',
        firstRound: 'First round',
        reserveRound: 'Reserve round',
        waiverTheRights: 'Waiver the rights'
    }
}

export const step4TH = {
    topic:{
        congratulations:'ผ่านเกณฑ์การคัดเลือก',
        notPass:`ไม่ผ่านเกณฑ์การคัดเลือก`,
        initiationDay: 'วันมอบตัว',
    },
    content:{
        examinationResult:'ผลการสอบคัดเลือก',
        confirm:'กรุณายืนยันสิทธิ์การเข้าศึกษาต่อภายในวันที่กำหนด กรณียืนยันสิทธิ์เข้าศึกษาโปรดระบุข้อมูลส่วนตัวเพิ่มเติม',
        timeout:'หมดเวลายืนยันสิทธิ์เข้าศึกษา',
        name:'ชื่อ - นามสกุล',
        type:'ประเภท',
        classroom:'ระดับชั้น',
        curriculum:'แผนการเรียน'
    },
    dialog:{
        topic:'ยืนยันสิทธิ์การเข้าศึกษา',
        content1:'หลังจากกดถัดไป',
        content2:'จะไม่สามารถแก้ไขข้อมูลได้',
        cancel:'ยกเลิก',
        next:'ถัดไป'
    },
    status:{
        qualified: 'ผ่านเกณฑ์',
        noQualified: 'ไม่ผ่านเกณฑ์',
        waiver: 'สละสิทธิ์',
        confirmEnrollment: 'ยืนยันสิทธิ์การเข้าศึกษา',
        successfulWaiver: 'สละสิทธิ์สำเร็จ',
        confirm: 'ยืนยัน',
        firstRound: 'ตัวจริง',
        reserveRound: 'ตัวสำรอง',
        waiverTheRights: 'สละยืนยันสิทธิ์การเข้าศึกษา'
    }
}

export const step5EN = {
    message:"Please follow the announcement from the school to prepare all documents for the initiation day",
    content:{
        topic:"Successful confirmation",
        message:"Please follow the announcement from the school to prepare all documents for the initiation day",
        name:'Firstname - Lastname',
        type:'Type',
        classroom:'Grade',
        curriculum:'Curriculum'
    },
}

export const step5TH = {
    content:{
        topic:"ยืนยันสิทธิ์สำเร็จ",
        message:"กรุณาติดตามประกาศจากทางโรงเรียนเพิ่มเติมเตรียมเอกสารให้ครบถ้วนสำหรับวันมอบตัว",
        name:'ชื่อ - นามสกุล',
        type:'ประเภท',
        classroom:'ระดับชั้น',
        curriculum:'แผนการเรียน'
    },
}

export const formSummitEN = {
    applicationForm:'Application Form',
    school:'School',
    status:'Status',
    time:'',
    timeline:'Time',
    deadlineFirstRound:'The deadline of the first round confirmation',
    deadlineReserveRound:'The deadline of the reserve round confirmation',
    initiationDay:'The initiation day',
    content1:'Candidates in the first round can confirm their rights / waiver from the date of announcement until the deadline of the first round',
    content2:'Candidates in the reserve round can confirm their rights / waiver from the deadline of first round until the deadline of the reserve round confirmation.',
    waiver:'Waiver',
    confirm:'Confirm the rights',
    within:'within',
    qualified: 'Qualified',
    noQualified: 'No qualified',
    // waiver: 'Waiver',
    confirmEnrollment: 'Confirm',
    successfulWaiver: 'Successful waiver',
    // confirm: 'Confirm',
    confirmPayment:'Confirm the payment',
    termOfPayment:'Term of payment',
    information:'The information is true, if the information is false, the school has the right to disqualify.',
    applicationPeriod: 'Application period',
    applicationFee: 'Application fee',
    submitApplication:"Submit application",
}

export const formSummitTH = {
    applicationForm:'ฟอร์มการสมัครเรียน',
    school:'โรงเรียน',
    status:'สถานะ',
    time:'น.',
    timeline:'เวลา',
    deadlineFirstRound:'วันสิ้นสุดการยืนยันสิทธิ์ (รอบตัวจริง)',
    deadlineReserveRound:'วันสิ้นสุดการยืนยันสิทธิ์ (รอบสำรอง)',
    initiationDay:'วันมอบตัว',
    content1:'ผู้สมัครรอบตัวจริงสามารถยืนยันสิทธิ์ / สละสิทธิ์ได้ตั้งแต่วันที่ประกาศผลจนถึงวันที่สิ้นสุดการยืนยันสิทธิ์รอบตัวจริง',
    content2:'ผู้สมัครรอบตัวสำรองสามารถยืนยันสิทธิ์ / สละสิทธิ์ได้ตั้งแต่วันสิ้นสุดการยืนยันสิทธิ์รอบตัวจริงจนถึงวันสิ้นสุดการยืนยันสิทธิ์รอบตัวสำรอง',
    waiver:'สละสิทธิ์',
    confirm:'ยืนยันสิทธิ์',
    within:'ภายใน',
    qualified: 'ผ่านเกณฑ์',
    noQualified: 'ไม่ผ่านเกณฑ์',
    // waiver: 'สละสิทธิ์',
    confirmEnrollment: 'ยืนยันสิทธิ์การเข้าศึกษา',
    successfulWaiver: 'สละสิทธิ์สำเร็จ',
    // confirm: 'ยืนยัน',
    confirmPayment:'ยืนยันการชำระเงิน',
    termOfPayment:'กำหนดการชำระเงิน',
    information:'ข้อความเป็นจริงทุกประการหากข้อมูลเป็นเท็จทางโรงเรียนมีสิทธิ์ตัดสิทธิ์',
    applicationPeriod: 'ช่วงเวลาการสมัคร',
    applicationFee: 'ค่าธรรมเนียมการสมัคร',
    submitApplication:"ส่งข้อมูลการสมัคร",
}

export const formEN = {
    topics:{
        classroomApplication:'Application Detail',
        studentInformation:'Applicants information',
        homeRegistration:'Legal address',
        presentAddress:'Present address',
        motherInformation:`Mother's information`,
        fatherInformation:`Father's information`,
        guardianInformation:'Parent information',
        family_relationships: 'Family relationships',
        other:'Other',
        educationalRecord:'Educational record',
        healthInformation:'Health information',
        documents:'Documents',
        formWarningContent: 'Please check and provide all additional information to confirm your rights.',
    },
    educationData:{
        formerSchool:'Former school',
        gpa:'GPAX',
        lastEducation:'Last education ',
        province:'Province',
        fillProvince:'Select the province ',
        district:'District',
        fillDistrict:'Select district',
        moveReason: 'Reason of moving',
        fillFormerSchool:'Please fill the former school',
        fillGpa:'Please fill GPAX',
        fillLastEducation:'Select your last education',
        fillMoveReason: 'Please fill reason of moving',
        errorGPALess:'Cumulative GPAX less than 4.00',
    },
    healthData:{
        weight:'Weight',
        height:'Height',
        bloodType:'Blood type',
        remark: 'Remark',
        fillRemark: 'Other ex. disabled',
        fillBloodType:'- Select -',
        medicalCondition:'Medical condition',
        drugAllergy:'Drug allergy',
        regularMedications:'Regular medications',
        fillMedicalCondition:'Please fill information of medical condition',
        fillDrugAllergy:'Please fill information of drug allergy',
        fillRegularMedications:'Please fill information of  regular medications',
        kg:'kg.',
        cm:'cm.',
        note:'note'
    },
    classData:{
        classroom:'Grade',
        curriculum:'Curriculum',
        fillClassroom:'- Select the grade -',
        fillCurriculum:'- Select the curriculum -',
        talent:'Talent',
        fillTalent:'Fill the talent',
        errorClassroom: 'Select the grade',
        errorCurriculum: 'Select the curriculum',
    },
    studentData:{
        studentImage: 'Profile image',
        imageOverSize: 'File type must be .jpg / .png with file size 50 KB - 200 KB',
        imageRules: {
            content1: 'Require student uniform',
            content2: 'Stand straight, face straight, and portrait',
            content3: 'No hat, dark glasses, and masks.',
            content4: 'Hair must not cover the forehead',
            content5: 'Use flat color for background (Not recommend white color)',
            content6: 'Not older than 6 months',
        },
        ID:'ID card number/ Passport No.',
        fillID:'Please fill ID card number/ Passport No.',
        leastID:'Please fill at least 10 digits',
        gender:'Gender',
        fillGender:'Please select gender',
        male:'Male',
        female:'Female',
        title:'Prefix',
        fillTitle:'- Select -',
        fillTitleTH:'Please fill prefix',
        fillTitleEN:'Please fill prefix',
        invalidTitle:'Select prefix',
        firstNameTH:'Firstname (TH)',
        firstNameEN:'Firstname (EN)',
        nickNameTH:'Nickname (TH)',
        nickNameEN:'Nickname (EN)',
        fillNickNameTH:'Please fill nickname',
        fillNickNameEN:'Please fill nickname',
        fillFirstNameTH:'Please fill the name',
        fillFirstNameEN:'Please fill the name',
        lastNameTH:'Lastname (TH)',
        lastNameEN:'Lastname (EN)',
        fillLastNameTH:'Please fill lastname',
        fillLastNameEN:'Please fill lastname',
        birthDate:'Birth date (B.C.)',
        fillBirthDate:'Please fill the birth date',
        date:'DD/MM/YY',
        mobileNo:'Mobile No.',
        fillMobileNo:'Please fill mobile No.',
        leastMobileNo:'Please fill mobile No. with 10 digits',
        ethnicity:'Ethnicity',
        fillEthnicity:'- Select ethnicity -',
        invalidEthnicity:'Please fill the ethnicity ',
        nationality:'Nationality',
        fillNationality:'- Select nationality -',
        invalidNationality:'Please fill the nationality ',
        religion:'religion',
        fillReligion:'- Select religion -',
        invalidReligion:'Please fill the religion ',
        birthplace:'Birthplace',
        fillBirthplace:'Please fill the birthplace',
        province:'Province',
        provinceOfBirthplace:'- Select province -',
        invalidProvinceOfBirthplace:'Select the province of the birthplace',
        siblings:'No siblings',
        child:'Number of relatives',
        numberOfChild:'Being the number of',

        firstName:'Firstname',
        lastName:'Lastname',
        grade: "Classroom",
        house: "House",
        fillFirstName:'Please fill name',
        fillLastName:'Please fill lastname',
        fillGrade:'Please fill grade',
        fillHouse:'Please fill house',
    },
    addressData:{
        address:'Address',
        fillAddress:'Please fill house No./Village',
        moo:'Moo',
        fillMoo:'Please fill moo',
        soi:'Soi',
        fillSoi:'Please fill soi',
        road:'Road',
        fillRoad:'Please fill road',
        province:'Province',
        invalidProvince:'Select province',
        fillProvince:'- Select the province -',
        subdistrict:'Sub-district',
        invalidSubdistrict:'Select sub-district',
        fillSubdistrict:'- Select the sub-district -',
        district:'District',
        invalidDistrict:'Select district',
        fillDistrict:'- Select the district -',
        postalCode:'Postal code',
        fillPostalCode:'Please fill postal code',
        useHomeRegis:'Use Legal address',

        addressType:'Living status',
        fillAddressType:'Select address type',
        invalidAddressType:'Select address',
        ownHome:'Own home',
        hiredHouse:'Hired house',
        livingWithOther:'Living with other',

        distance:'Distance from home to school',
        fillDistance:'Please fill distance from home to school',
        invalidDistance:'Please fill integer',

        transport:'Transport',
        fillTransport:'Select transport type',
        walkBike:'Walk, Bike',
        schoolBus:'School Bus',
        Motorcycle:'Motorcycle',
        personalCar:'Personal car',
        publicTransport:'Public transport',
        km:'km',
    },
    parentData:{
        father:'Father',
        mother:'Mother',
        fatherMobileNo:"Mobile no.",
        motherMobileNo:"Mobile no.",
        email:'Email',
        fillEmail:'Please fill email',
        salary:'Salary per month (THB)',
        fillSalary:'- Select salary per month -',
        invalidSalary:'- Select salary per month -',
        career:'Career',
        position: "Position",
        workPlace: "Work place",
        fillCareer:'Ex. officer',
        fillPosition:'Ex. position',
        fillWorkPlace:'Ex. workplace',
        fillAllowance: '- Select -',

        familyStatus:'Family status',
        together:'Together',
        divorce:'Divorce',
        separated:'Separated',
        deceased:'Father and Mother deceased',
        father_deceased:'Father deceased',
        mother_deceased:'Mother deceased',
        other:'Other',

        siblings_study_together: "Does the student have siblings studying at King's College School ?",
        siblings_study_yes: "Yes",
        siblings_study_no: "No",
        siblings_name: "Firstname",
        siblings_surname: "Lastname",
        siblings_grade: "Grade",
        siblings_house: "House",

        personTakeCare:"Person who take care of students 's expenses",
        usePresentAddress:'Use present address',

        fatherNotListed: `Do not have father's information`,
        motherNotListed: `Do not have mother's information`,
    }
}

export const formTH = {
    topics:{
        classroomApplication:'ระดับชั้นที่ต้องการสมัคร',
        studentInformation:'ข้อมูลนักเรียน',
        homeRegistration:'ที่อยู่ตามทะเบียนบ้าน',
        presentAddress:'ที่อยู่ปัจจุบัน',
        motherInformation:'ข้อมูลมารดา',
        fatherInformation:'ข้อมูลบิดา',
        guardianInformation:'ข้อมูลผู้ปกครอง',
        family_relationships: 'ความสัมพันธ์ในครอบครัว',
        other:'ข้อมูลอื่นๆ',
        educationalRecord:'ประวัติการศึกษา',
        healthInformation:'ข้อมูลสุขภาพ',
        documents:'หลักฐานการสมัคร',
        formWarningContent: 'กรุณาตรวจสอบ และระบุข้อมูลเพิ่มเติมทั้งหมดเพื่อยืนยันสิทธิ์การเข้าศึกษา'
    },
    educationData:{
        formerSchool:'สถานศึกษาเดิม',
        gpa:'เกรดเฉลี่ยสะสม',
        lastEducation:'ชั้นเรียนสุดท้าย',
        province:'จังหวัด',
        fillProvince:'เลือกจังหวัด',
        district:'เขต / อำเภอ',
        fillDistrict:'เลือกแขวง / ตำบล',
        moveReason: 'เหตุที่ย้าย',
        fillFormerSchool:'ระบุชื่อสถานศึกษา',
        fillGpa:'ระบุเกรดเฉลี่ยสะสม',
        fillLastEducation:'เลือกชั้นเรียนสุดท้าย',
        fillMoveReason: 'ระบุเหตุที่ย้าย',
        errorGPALess:'เกรดเฉลี่ยสะสมน้อยกว่า 4.00',
    },
    healthData:{
        weight:'น้ำหนัก',
        height:'ส่วนสูง',
        bloodType:'หมู่เลือด',
        remark: 'หมายเหตุ',
        fillRemark: 'อื่นๆ เช่น เป็นผู้พิการ',
        fillBloodType:'- เลือก -',
        medicalCondition:'โรคประจำตัว',
        drugAllergy:'แพ้ยา',
        regularMedications:'ยาที่ทานประจำ',
        fillMedicalCondition:'ระบุโรคประจำตัว',
        fillDrugAllergy:'ระบุยาที่แพ้',
        fillRegularMedications:'ระบุยาที่ทานประจำ',
        kg:'กก.',
        cm:'ซม.',
        note:'หมายเหตุ'
    },
    classData:{
        classroom:'ระดับชั้น',
        curriculum:'แผนการเรียน',
        fillClassroom:'- เลือกระดับชั้น -',
        fillCurriculum:'- เลือกแผนการเรียน -',
        talent:'ความสามารถพิเศษ',
        fillTalent:'ระบุความสามารถพิเศษ',
        errorClassroom: 'เลือกระดับชั้น',
        errorCurriculum: 'เลือกแผนการเรียน',
    },
    studentData:{
        studentImage: 'รูปนักเรียน',
        imageOverSize: 'ไฟล์ .jpg / .png ขนาด 50 KB - 200 KB',
        imageRules: {
            content1: 'สวมเครื่องแบบนักเรียน',
            content2: 'ยืนตัวตรง หน้าตรง ครึ่งตัว (แนวตั้ง)',
            content3: 'ไม่สวมหมวก หรือแว่นตาดำ และไม่สวมหน้ากาก',
            content4: 'นักเรียน ผมไม่ปิดหน้าผาก',
            content5: 'พื้นหลังสีเรียบ (ไม่แนะนำพื้นหลังสีขาว)',
            content6: 'ถ่ายไว้ไม่เกิน 6 เดือน',
        },
        ID:'รหัสบัตรประชาชน / พาสปอร์ต',
        fillID:'ระบุบัตรประชาชน / พาสปอร์ต',
        leastID:'ระบุอย่างน้อย 10 ตัวอักษร / ตัวเลข',
        gender:'เพศ',
        fillGender:'กรุณาเลือกเพศ',
        title:'คำนำหน้า',
        fillTitle:'- เลือก -',
        fillTitleTH:'ระบุคำนำหน้า ภาษาไทย',
        fillTitleEN:'ระบุคำนำหน้า ภาษาอังกฤษ',
        invalidTitle:'เลือกคำนำหน้า',
        male:'ชาย',
        female:'หญิง',
        firstNameTH:'ชื่อ (ไทย)',
        firstNameEN:'ชื่อ (อังกฤษ)',
        nickNameTH:'ชื่อเล่น (ไทย)',
        nickNameEN:'ชื่อเล่น (อังกฤษ)',
        fillNickNameTH:'ระบุชื่อเล่น ภาษาไทย',
        fillNickNameEN:'ระบุชื่อเล่น ภาษาอังกฤษ',
        fillFirstNameTH:'ระบุชื่อ ภาษาไทย',
        fillFirstNameEN:'ระบุชื่อ ภาษาอังกฤษ',
        lastNameTH:'นามสกุล (ไทย)',
        lastNameEN:'นามสกุล (อังกฤษ)',
        fillLastNameTH:'ระบุนามสกุล ภาษาไทย',
        fillLastNameEN:'ระบุนามสกุล ภาษาอังกฤษ',
        birthDate:'วันเกิด(พ.ศ.)',
        fillBirthDate:'ระบุวันเกิด',
        date:'วว/ดด/ปป',
        mobileNo:'เบอร์โทรศัพท์',
        fillMobileNo:'ระบุเบอร์โทรศัพท์',
        leastMobileNo:'กรุณาระบุเบอร์ 10 หลัก',

        ethnicity:'เชื้อชาติ',
        fillEthnicity:'- เลือกเชื้อชาติ -',
        invalidEthnicity:'เลือกเชื้อชาติ',
        nationality:'สัญชาติ',
        fillNationality:'- เลือกสัญชาติ -',
        invalidNationality:'เลือกสัญชาติ',
        religion:'ศาสนา',
        fillReligion:'- เลือกศาสนา -',
        invalidReligion:'เลือกศาสนา',

        birthplace:'โรงพยาบาลที่เกิด',
        fillBirthplace:'ระบุชื่อโรงพยาบาล',
        province:'จังหวัด',
        provinceOfBirthplace:'- เลือกจังหวัด -',
        invalidProvinceOfBirthplace:'เลือกจังหวัดโรงพยาบาล',
        siblings:'ไม่มีพี่น้องร่วมบิดามารดา',
        child:'เป็นบุตรคนที่',
        numberOfChild:'จำนวนพี่น้อง',

        firstName:'ชื่อ',
        lastName:'นามสกุล',
        grade: "ชั้น",
        house: "บ้าน",
        fillFirstName:'ระบุชื่อ',
        fillLastName:'ระบุนามสกุล',
        fillGrade:'ระบุชั้น',
        fillHouse:'ระบุบ้าน',
    },
    addressData:{
        address:'ที่อยู่',
        fillAddress:'ระบุบ้านเลขที่',
        moo:'หมู่ที่',
        fillMoo:'ระบุหมู่ที่',
        soi:'ตรอก/ซอย',
        fillSoi:'ระบุตรอก/ซอย',
        road:'ถนน',
        fillRoad:'ระบุถนน',
        province:'จังหวัด',
        invalidProvince:'เลือกจังหวัด',
        fillProvince:'- เลือกจังหวัด -',
        subdistrict:'แขวง / ตำบล',
        invalidSubdistrict: 'เลือกแขวง / ตำบล',
        fillSubdistrict:'- เลือกแขวง / ตำบล -',
        district:'เขต / อำเภอ',
        invalidDistrict: 'เลือกเขต / อำเภอ',
        fillDistrict:'- เลือกเขต / อำเภอ -',
        postalCode:'รหัสไปรษณีย์',
        fillPostalCode:'ระบุรหัสไปรษณีย์',
        useHomeRegis:'ใช้ที่อยู่ตามทะเบียนบ้าน',

        addressType:'ที่พักอาศัย',
        fillAddressType:'เลือกประเภทที่พักอาศัย',
        invalidAddressType:'เลือกประเภทที่พักอาศัย',
        ownHome:'บ้านพักตนเอง',
        hiredHouse:'บ้านเช่า',
        livingWithOther:'อาศัยกับผู้อื่น',

        distance:'ระยะทางจากบ้านถึงโรงเรียน',
        fillDistance:'ระบุระยะทางจากบ้านถึงโรงเรียน',
        invalidDistance:'กรุณาระบุจำนวนเต็ม',

        transport:'การเดินทางมาโรงเรียน',
        fillTransport:'เลือกประเภทการเดินทางมาโรงเรียน',
        walkBike:'เดิน,รถจักรยาน',
        schoolBus:'รถรับส่ง',
        Motorcycle:'รถจักรยานยนต์',
        personalCar:'รถยนต์ส่วนตัว',
        publicTransport:'รถสาธารณะ',
        km:'กม.',

    },
    parentData:{
        father:'บิดา',
        mother:'มารดา',
        fatherMobileNo:'เบอร์โทรศัพท์บิดา',
        motherMobileNo:'เบอร์โทรศัพท์มารดา',
        email:'อีเมล',
        fillEmail:'ระบุอีเมล',
        salary:'รายได้ต่อเดือน (บาท)',
        fillSalary:'- เลือกรายได้ต่อเดือน -',
        invalidSalary:'เลือกรายได้ต่อเดือน',
        career:'อาชีพ',
        position: "ตำแหน่ง",
        workPlace: "ที่ทำงาน",
        fillCareer:'เช่นอาชีพ พนักงานทั่วไป',
        fillPosition:'เช่นตำแหน่ง พนักงานขาย',
        fillWorkPlace:'เช่น ที่ทำงาน',
        fillAllowance: '- เลือก -',

        familyStatus:'สถานภาพครอบครัว',
        together:'อยู่ด้วยกัน',
        divorce:'หย่าร้าง',
        separated:'แยกกันอยู่',
        deceased:'บิดาและมารดาเสียชีวิต',
        father_deceased:'บิดาเสียชีวิต',
        mother_deceased:'มารดาเสียชีวิต',
        other:'อื่นๆ',

        siblings_study_together:'ผู้สมัครมีพี่น้องเรียนอยู่โรงเรียน ภ.ป.ร. ราชวิทยาลัย ในพระบรมราชูปถัมภ์ หรือไม่',
        siblings_study_yes: "มี",
        siblings_study_no: "ไม่มี",
        siblings_name: "ชื่อ",
        siblings_surname: "นามสกุล",
        siblings_grade: "ชั้น",
        siblings_house: "บ้าน",

        personTakeCare:"นักเรียนรับค่าใช้จ่ายจากใคร",
        usePresentAddress:'ใช้ทีอยู่ปัจจุบันของนักเรียน',

        fatherNotListed: 'ไม่ปรากฎบิดา',
        motherNotListed: 'ไม่ปรากฎมารดา',
    },
    familyRelationships: {
        together: 'อยู่ด้วยกัน',
        divorce: 'หย่าร้าง',
        separated: 'แยกกันอยู่',
        father_deceased: 'บิดาเสียชีวิต',
        mother_deceased: 'มารดาเสียชีวิต',
    }
}

export const docTH={
    copyOfIDCard:'สำเนาบัตรประชาชนนักเรียน',
    copyOfHomeRegistration:'สำเนาทะเบียนบ้านนักเรียน',
    copyOfBirthCertificate:'สำเนาสูติบัตร',
    copyOfNameChange:'สำเนาหลักฐานการเปลี่ยนชื่อ - สกุล',
    copyOfLegitimationOfChild:'สำเนาใบจดทะเบียนเป็นบุตรบุญธรรม',
    medicalCertificate:'ใบรับรองแพทย์',
    copyOfTranscript:'สำเนาระเบียนแสดงผลการเรียน (ปพ.1) ด้านหน้าและด้านหลัง',
    portfolio:'แฟ้มสะสมผลงาน (Portfolio)' ,

    extraDoc1: 'ใบสมัครของโรงเรียน',
    extraDoc2: 'ใบรับรองกำลังศึกษา',
    extraDoc3: 'ใบแสดงผลการเรียนเฉลี่ย',
    extraDoc4: 'ใบรับรองแพทย์',
    extraDoc5: 'รูปถ่ายเครื่องแบบนักเรียน',
    extraDoc6: 'สำเนาทะเบียนบ้านนักเรียน',

    suchAs:'เช่น',
    content_name_of_file:'ตั้งชื่อไฟลดังนี้',
    content_evidence_file_info: 'รองรับไฟล์ประเภท PDF ขนาดไม่เกิน 10 MB',
    content_copyOfIDCard:'สำเนาบัตรประชาชน_ชื่อ_นามสกุล',
    content_copyOfHomeRegistration:'สำเนาทะเบียนบ้าน_ชื่อ_นามสกุล',
    content_copyOfBirthCertificate:'สำเนาสูติบัตร_ชื่อ_นามสกุล',
    content_copyOfNameChange:'สำเนาการเปลี่ยนชื่อ_ชื่อ_นามสกุล',
    content_copyOfLegitimationOfChild:'สำเนาทะเบียนบุตรบุญธรรม_ชื่อ_นามสกุล',
    content_medicalCertificate:'ใบรับรองแพทย์_ชื่อ_นามสกุล',
    content_CopyOfTranscript:'สำเนาปพ1_ชื่อ_นามสกุล',
    content_portfolio:'แฟ้มสะสมผลงาน_ชื่อ_นามสกุล',

    exam_copyOfIDCard:'สำเนาบัตรประชาชน_สมชาย_ใจดี',
    exam_copyOfHomeRegistration:'สำเนาทะเบียนบ้าน_สมชาย_ใจดี',
    exam_copyOfBirthCertificate:'สำเนาสูติบัตร_สมชาย_ใจดี',
    exam_copyOfNameChange:'สำเนาการเปลี่ยนชื่อ_สมชาย_ใจดี',
    exam_copyOfLegitimationOfChild:'สำเนาทะเบียนบุตรบุญธรรม_สมชาย_ใจดี',
    exam_medicalCertificate:'ใบรับรองแพทย์_สมชาย_ใจดี',
    exam_CopyOfTranscript:'สำเนาปพ1_สมชาย_ใจดี',
    exam_portfolio:'แฟ้มสะสมผลงาน_สมชาย_ใจดี',
    exam_name:'สมชาย_ใจดี',
    content_name:'ชื่อ_นามสกุล',

    AchievePayment:'แนบไฟล์หลักฐานการชำระเงิน (e-Slip)',
}

export const docEN={
    copyOfIDCard:'Copy of ID Card',
    copyOfHomeRegistration:'Copy of Home Registration',
    copyOfBirthCertificate:'Copy of Birth Certificate',
    copyOfNameChange:'Copy of Certificate of First Name Change',
    copyOfLegitimationOfChild:'Copy of Legitimationof Child',
    medicalCertificate:'Medical certificate',
    copyOfTranscript:'Copy of transcript',
    portfolio:'Portfolio',

    extraDoc1: 'ใบสมัครของโรงเรียน',
    extraDoc2: 'ใบรับรองกำลังศึกษา',
    extraDoc3: 'ใบแสดงผลการเรียนเฉลี่ย',
    extraDoc4: 'ใบรับรองแพทย์',
    extraDoc5: 'รูปถ่ายเครื่องแบบนักเรียน',
    extraDoc6: 'สำเนาทะเบียนบ้านนักเรียน',

    suchAs:'such as',
    content_name_of_file:'Name the file as follows',
    content_evidence_file_info: 'Supports PDF file type with a size not exceeding 10 MB.',
    content_copyOfIDCard:'copy_of_id_card_name_surname',
    content_copyOfHomeRegistration:'copy_of_home_registration_name_surname',
    content_copyOfBirthCertificate:'copy_of_birth_certificate_name_surname',
    content_copyOfNameChange:'copy_of_certificate_of_first_name_change_name_surname',
    content_copyOfLegitimationOfChild:'copy_of_legitimation_of_child_name_surname',
    content_medicalCertificate:'medical_certificate_name_surname',
    content_CopyOfTranscript:'copy_of_transcript_name_surname',
    content_portfolio:'portfolioname_surname',

    exam_copyOfIDCard:'copy_of_id_card_Somchai_Jaidee',
    exam_copyOfHomeRegistration:'copy_of_home_registration_Somchai_Jaidee',
    exam_copyOfBirthCertificate:'copy_of_birth_certificate_Somchai_Jaidee',
    exam_copyOfNameChange:'copy_of_certificate_of_first_name_change_Somchai_Jaidee',
    exam_copyOfLegitimationOfChild:'copy_of_legitimation_of_child_Somchai_Jaidee',
    exam_medicalCertificate:'medical_certificate_Somchai_Jaidee',
    exam_CopyOfTranscript:'copy_of_transcript_Somchai_Jaidee',
    exam_portfolio:'portfolio_Somchai_Jaidee',
    exam_name:'Somchai_Jaidee',
    content_name:'name_surname',

    AchievePayment:'Achieve a payment slip',
}

export const stepperBarTH = {
    register: "ลงทะเบียน",
    payment: "ชำระเงิน",
    qualifiedCandidates: "ประกาศสิทธิ์สอบ",
    examinationResult: "ประกาศผลสอบ",
    confirmation:  "ยืนยันสิทธิ์เข้าศึกษา"
}

export const stepperBarEN = {
    register: "Register",
    payment: "Payment",
    qualifiedCandidates: "Announcement of qualified candidates",
    examinationResult: "Announcement of examination result",
    confirmation:  "Confirm"
}

